
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"50%","cy":"50%","r":"50%","fill":"#41C8C3"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1 9a8 8 0 1016 0A8 8 0 001 9zm1.6 0a6.4 6.4 0 1112.8 0A6.4 6.4 0 012.6 9zm10.19-1.86a.8.8 0 10-1.18-1.08L7.83 10.184 6.415 8.488a.8.8 0 00-1.23 1.024l2 2.4a.8.8 0 001.205.029l4.4-4.8z","fill":"#fff"}})])
          )
        }
      }
    